import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=0bee3c72&scoped=true&"
import script from "./resources.vue?vue&type=script&lang=js&"
export * from "./resources.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/resource/resources.less?vue&type=style&index=0&id=0bee3c72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee3c72",
  null
  
)

component.options.__file = "resources.vue"
export default component.exports